/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Time periods
 */
export class ReferralPeriod {
  constructor(json: JSON | any) {
    Object.assign(this as ReferralPeriod, json)
  }

  /**
   * The date (unix epoch in ms) when the referral period initiated, will be filled instantaneously.
   */
  startDate?: number
  /**
   * The date (unix epoch in ms) the referral period ended, will be instantaneously filled.
   */
  endDate?: number
  /**
   * Comments made during the referral.
   */
  comment?: string
}
